import React from 'react';
import { Spinner, Box } from '@chakra-ui/react';

const Loader = () => (
  <Box 
    minH="100vh" 
    display="flex" 
    alignItems="center" 
    justifyContent="center"
  >
    <Spinner size="xl" />
  </Box>
);

export default Loader;
